const KEY = 'user'
// const Last = 'last_student_sn'
export default {
  setPayData (PayData) {
    window.sessionStorage.setItem('PayData', JSON.stringify(PayData))
  },
  getPayData () {
    return JSON.parse(window.sessionStorage.getItem('PayData') || '{}')
  },

}



// WEBPACK FOOTER //
// ./src/store/store.js